import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Folder } from 'src/app/interfaces/folder';

@Injectable({
  providedIn: 'root'
})
export class FolderUpdateService {
  private folderUpdatedSource = new BehaviorSubject<Folder[] | null>(null);

  folderUpdated$ = this.folderUpdatedSource.asObservable();

  updateFolder(folder: Folder[]) {
    this.folderUpdatedSource.next(folder);
  }
}
